import { db } from '@/config/firebase';
import { DateUtil } from "@/utils/dateutil";

function generateQuery(filter, collectionName) {
    let query = db.collection(collectionName);

    if (filter) {
        if (filter.company) {
            query = query.where('filterCompanyId', '==', filter.company.id);
        }

        const monthYears = DateUtil.getMonthsAndYearsInRange(filter.fromTimestamp, filter.toTimestamp);
        const monthYearsKey = monthYears.join('_');

        if (monthYearsKey) {
            query = query.where('filterMonthYearKey', '==', monthYearsKey)
        }
    }

    return query;
}

function getDashboardListener(filter, callback, collectionName) {
    let query = generateQuery(filter, collectionName);

    let listener = query.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
            let doc = change.doc.data();
            doc.id = change.doc.id;

            callback(change.type, doc);
        });
    });

    return listener;
}

export default {
    getDashboardListener,
};